import {
  mobileHeader,
  mobileIconBtn,
  mobileRoot,
} from "../theme";

export default function MobilePage({ title, onMenu, onBack, action, children }) {
  return (
    <div className={mobileRoot}>
      <header className={mobileHeader}>
        {onBack ? (
          <button
            type="button"
            onClick={onBack}
            aria-label="Voltar"
            className={mobileIconBtn}
          >
            ←
          </button>
        ) : onMenu ? (
          <button
            type="button"
            onClick={onMenu}
            aria-label="Menu"
            className={mobileIconBtn}
          >
            ☰
          </button>
        ) : (
          <span className="min-h-[44px] min-w-[44px]" />
        )}
        <h1 className="flex-1 truncate text-lg font-semibold text-laranjinha">{title}</h1>
        {action ? <div className="shrink-0">{action}</div> : <span className="min-w-[44px]" />}
      </header>
      <main className="flex-1 overflow-y-auto bg-mgs-bg">{children}</main>
    </div>
  );
}
